import React from 'react';
import { SVG, SVGIcon } from '../../../atoms/SVG';
import { Heading, HeadingHierarchy } from '../../../../_lib/components/Heading/Heading';

type WidgetHeaderProps = {
  id: string;
  svgSpriteId?: SVGIcon;
  title: string;
  headlineHierarchy?: HeadingHierarchy;
  hasIcon?: boolean;
  invisible?: boolean;
};

export default function WidgetHeader({
  svgSpriteId,
  headlineHierarchy,
  id,
  hasIcon = true,
  title,
  invisible = false,
}: WidgetHeaderProps) {
  /**
   * Get SVG Sprite only if we want it, else we wont render the image at all.
   * this will also correctly render our titles if there is no image.
   */
  const getSVGSprite = () => {
    return svgSpriteId ? (
      <span className="widget-header__iconcontainer">
        <SVG svgSpriteId={svgSpriteId} />
      </span>
    ) : null;
  };

  /**
   * Creating the Widget Header
   * It mostly consists of a h2, in special cases (PAL)
   * @return {*}
   */

  const getHeadline = () => {
    return (
      <Heading hierarchy={headlineHierarchy || 2} className="widget-header__title" id={`widget-header-${id}`}>
        {hasIcon && getSVGSprite()}
        <span className="widget-header__title-text">{title}</span>
      </Heading>
    );
  };

  const classes = invisible ? 'widget-header__header invisible' : 'widget-header__header';

  return <header className={classes}>{getHeadline()}</header>;
}
